import { useEffect, useState } from 'react';
import { getMe, tokenExists } from '../api/auth';

let cachedUser = null;
let inflight = null;

const fetchCurrentUser = async () => {
  if (cachedUser) return cachedUser;
  if (!inflight) {
    inflight = getMe()
      .then((data) => {
        cachedUser = data;
        inflight = null;
        return data;
      })
      .catch((error) => {
        inflight = null;
        throw error;
      });
  }
  return inflight;
};

export const clearCurrentUserCache = () => {
  cachedUser = null;
  inflight = null;
};

const useCurrentUser = () => {
  const [state, setState] = useState(() => ({
    user: cachedUser,
    status: cachedUser ? 'ready' : 'idle',
  }));

  useEffect(() => {
    let mounted = true;
    if (!tokenExists()) {
      setState({ user: null, status: 'unauthorized' });
      return () => {};
    }
    if (cachedUser) {
      setState({ user: cachedUser, status: 'ready' });
      return () => {};
    }
    setState({ user: null, status: 'loading' });
    fetchCurrentUser()
      .then((data) => {
        if (!mounted) return;
        setState({ user: data, status: 'ready' });
      })
      .catch(() => {
        if (!mounted) return;
        setState({ user: null, status: 'unauthorized' });
      });
    return () => {
      mounted = false;
    };
  }, []);

  return state;
};

export default useCurrentUser;
